export const hasRoles = (roles, userRoles) => {
  if (!userRoles) {
    return false;
  }
  if (!roles) {
    return true;
  }
  return Object.keys(userRoles).some(
    clientName =>
      userRoles[clientName] &&
      roles[clientName] &&
      userRoles[clientName].some(role => roles[clientName].some(pr => role === pr))
  );
};
